var index = {
  root: {
    background: '{content.background}',
    borderColor: '{content.background}',
    borderRadius: 'none',
    color: '{content.color}',
    gap: '0.5rem',
    padding: '0.75rem',
  },
};

export { index as default };
//# sourceMappingURL=index.mjs.map
